import { render, staticRenderFns } from "./CustomerCenter.vue?vue&type=template&id=0555559d&scoped=true"
import script from "./CustomerCenter.vue?vue&type=script&lang=js"
export * from "./CustomerCenter.vue?vue&type=script&lang=js"
import style0 from "./CustomerCenter.vue?vue&type=style&index=0&id=0555559d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555559d",
  null
  
)

export default component.exports